export default {
  name: 'TheHeader',
  data() {
    return {};
  },
  computed: {
    isNotFoundPage() {
      return this.$route.name === 'notFound';
    },
    isMethodology() {
      return this.$route.name === 'methodology';
    },
    isHome() {
      return this.$route.name === 'home';
    }
  },
  watch: {},
  mounted() {},
  methods: {}
};